import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    if (typeof window.Sortable === "undefined") return
    this.sortable = new window.Sortable(this.element, {
      animation: 150,
      handle: ".js-collection-order-handle",
      onEnd: this.onEnd.bind(this),
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  onEnd({ oldIndex, newIndex }) {
    if (oldIndex === newIndex) return

    const csrfToken = this.element.querySelector('input[name="csrf_token"]')?.value
    const gitSha = this.element.querySelector('input[name="_git_sha"]')?.value
    if (!csrfToken || !gitSha) return

    const form = document.createElement("form")
    form.method = "post"
    form.action = this.urlValue
    form.append(
      this.hiddenInput("csrf_token", csrfToken),
      this.hiddenInput("_git_sha", gitSha),
    )
    this.element
      .querySelectorAll("[data-collection-order-document-value]")
      .forEach(row => form.append(this.hiddenInput("document", row.dataset.collectionOrderDocumentValue)))
    document.body.append(form)
    form.submit()
  }

  hiddenInput(name, value) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value
    return input
  }
}
